function updateItem(data_line, data_qty, properties = {}) {
  const data = { id: data_line, quantity: data_qty, properties: properties };
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
  .then((response) => response.json())
  .then((data) => {
    if (document.location.href.indexOf('/cart') > -1) {
      window.location.href = "/cart";
    } else {
      if(typeof load_cart === 'function'){
        load_cart();
        setTimeout(function(e) {
          cartNotification(data_line);
        }, 500);
      } else {
        cartNotification(data_line);
      }
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

function addNewLineItem(data_line) {
  const data = {
    id: data_line,
    quantity: 1,
    properties: {
      _unique: `${data_line}:${Date.now()}:${Math.random().toString(36).substring(2, 15)}`
    }
  };

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  })
  .then((response) => response.json())
  .then((data) => {
    if (document.location.href.indexOf('/cart') > -1) {
      window.location.href = "/cart";
    } else {
      if (typeof load_cart === 'function') {
        load_cart();
        setTimeout(function () {
          cartNotification(data_line);
        }, 500);
      } else {
        cartNotification(data_line);
      }
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}

function qty_box(){
  document.querySelectorAll('.ci_plus a').forEach(function(plus) {
    plus.addEventListener('click', function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      // var input = plus.closest('.ci_qtybox').querySelector('.cart_qty');
      // input.value = parseInt(input.value) + 1;
      var new_line = this.getAttribute('data-line-item');
      // var new_qty = this.closest('.ci_qtybox').querySelector('.cart_qty').value;
      addNewLineItem(new_line);
    });
  });
  document.querySelectorAll('.ci_minus a').forEach(function(minus) {
    minus.addEventListener('click', function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      var centerQtyInput = minus.closest('.ci_qtybox').querySelector('.cart_qty');
      var currentQty = parseInt(centerQtyInput.value);
      if(currentQty > 0){
        centerQtyInput.value = currentQty - 1;
        var newLine = this.getAttribute('data-line-item');
        var newQty = this.closest('.ci_qtybox').querySelector('.cart_qty').value;
        // Retrieve the unique property for this line
        var uniqueProperty = this.closest('.item-row').getAttribute('data-unique');
        // Pass the unique property to the updateItem function
        // updateItem(newLine, newQty, { _unique: uniqueProperty });
        updateItem(newLine, newQty, { _unique: `${uniqueProperty}:${Date.now()}:${Math.random().toString(36).substring(2, 15)}` });
      }
    });
  });
  document.querySelectorAll('.quick_view_button').forEach((quickBtn) => {
    quickBtn.addEventListener('click',function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      let url = quickBtn.getAttribute('data-url');
      let modal = quickBtn.getAttribute('data-modal');
      fetch(url)
      .then((response) => response.text())
      .then((response) => {
        const html = new DOMParser().parseFromString(response, 'text/html');
        const source = html.getElementById('section-quick-buy');
        // document.querySelector('body').classList.remove('open-drawer');
        document.querySelector('body').classList.add('open-quick-buy');
        if(quickBtn.closest('.cd-also-like')){
          document.querySelector('body').classList.add('add-from-cart');
        }
        document.getElementById(modal).getElementsByClassName('quick-buy-popup')[0].innerHTML = source.innerHTML;
        document.dispatchEvent(new CustomEvent("quickview:loaded"));
        addToCart();
      })
      .catch((e) => {console.error(e);})
    })
  })
  if(document.querySelectorAll('.cd-shi-ret-head li')) document.querySelectorAll('.cd-shi-ret-head li').forEach((tabTitle) => {
    tabTitle.addEventListener('click',function(e){
      e.preventDefault();
      document.querySelectorAll('.cd-shi-ret-head li').forEach((tabTitle) => {
        tabTitle.classList.remove('active-cd-head');
      })
      tabTitle.classList.add('active-cd-head');
      let val = tabTitle.getAttribute('data-val');
      document.querySelectorAll('.cd-shi-ret-cont li').forEach((tabContent) => {
        let allVal = tabContent.getAttribute('data-val');
        if(val == allVal){
          document.querySelectorAll('.cd-shi-ret-cont li').forEach((tabContent) => {
            tabContent.classList.remove('active-cd-cont');
          })
          tabContent.classList.add('active-cd-cont');
        }
      })
    })
  })
  let cd_middle = document.querySelector('.cd_middle');
  if(cd_middle)  cd_middle.addEventListener('scroll',(e) => {
    let searchTop = cd_middle.scrollTop;
    if(searchTop > 0){
      document.querySelector('.cart-sidebar').classList.add('cd-sticky-head');
    }else{
      document.querySelector('.cart-sidebar').classList.remove('cd-sticky-head');
    }
  });
  let cdVariantBox = document.querySelectorAll(".cd_variant_cls");
  let opencdVariantBox = (variantBox) => {variantBox.classList.add("active");}
  let closecdVariantBox = (variantBox) => {variantBox.classList.remove("active");}
  cdVariantBox.forEach((variantBox) => {
    let btn = variantBox.querySelector(".cd_variantbtn");
    if(btn) btn.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopImmediatePropagation();
      cdVariantBox.forEach((box) => {
        if(box !== variantBox){closecdVariantBox(box);}
      });
      if(variantBox.classList.contains("active")){
        closecdVariantBox(variantBox);
      }else{
        opencdVariantBox(variantBox);
      }
    });
  });
  document.querySelectorAll('.cd_variant').forEach(function(cdVariantAdd) {
    cdVariantAdd.addEventListener('click', function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      cdVariantAdd.closest('.cd_variant_cls').classList.remove('active');
      let cart_error = cdVariantAdd.closest('.item-row').querySelector('.cierror');
      let currentid = cdVariantAdd.closest('.item-row').querySelector('.item-remove').getAttribute('data-line');
      let changevar_id = cdVariantAdd.getAttribute('data-id');
      let item_current_qty = cdVariantAdd.closest('.item-row').querySelector('.cart_qty').value;
      let formData = {
        'items': [{'id': changevar_id,'quantity': item_current_qty, 'properties': {
          _unique: `${changevar_id}:${Date.now()}:${Math.random().toString(36).substring(2, 15)}`
        }}]
      };
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json',},
        body: JSON.stringify(formData),
      })
      .then((response) => response.json())
      .then((data) => {
        setTimeout(function(e){
          removeItem(currentid,0);
        },500);
      })
      .catch((error) => {
        console.error('error',error);
        cart_error.text(e.responseJSON.description);
        setTimeout(function(){
          cart_error.text('');
        },2000);
      });
    })
  })
  if(document.querySelector('.cd-second-off-close')) document.querySelector('.cd-second-off-close').addEventListener('click',function(e){
    e.preventDefault();
    document.querySelector('.cd-second-off').classList.add('hide-second-off');
  })
  document.querySelectorAll('.cd__variant_close').forEach((cd_variant_close) => {
    cd_variant_close.addEventListener('click',function(e){
      e.preventDefault();
      cd_variant_close.closest('.cd_variant_cls').classList.remove('active');
    });
  });
  let cd__variant_list = document.querySelector('.cd__variant_list');
  if(cd__variant_list)  cd__variant_list.addEventListener('scroll',(e) => {
    let searchTop = cd__variant_list.scrollTop;
    if(searchTop > 0){
      document.querySelector('.cd__variant_list').classList.add('active_scroll');
    }else{
      document.querySelector('.cd__variant_list').classList.remove('active_scroll');
    }
  });
}
qty_box();
function load_cart(){
  fetch(window.Shopify.routes.root +'?section_id=cart-drawer')
  .then((response) => response.text())
  .then((responseText) => {
    const cartid = 'cart-drawer';
    const html = new DOMParser().parseFromString(responseText, 'text/html')  
    const destination = document.querySelector('.cart-sidebar');
    const source = html.getElementById(cartid);
    if (source && destination) destination.innerHTML = source.innerHTML;
    qty_box();
    document.querySelectorAll('.item-remove').forEach(function(cartRemove){
      var data_line = cartRemove.dataset.line;
      cartRemove.addEventListener('click',(evt) => removeItem(data_line,0));
    });
    let drawerConsider = new Swiper(".cd-also-like", {
      slidesPerView: 'auto',
      loop: true,
      centeredSlides: true,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
        pauseOnMouseEnter: true,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
        hide: true,
      },
    });

    function input_box(){
      document.addEventListener('keyup', function(e){
        if(e.target.matches('.docapp-cart-with-coupon-summary input[type=text].docapp-coupon-input--input')){
          if(e.target.value != ''){
            document.querySelector('.docapp-cart-with-coupon-summary .docapp-coupon-input--input-container').classList.add('active-input');
          }else{
            document.querySelector('.docapp-cart-with-coupon-summary .docapp-coupon-input--input-container').classList.remove('active-input');
          }
        }
      });
      document.addEventListener('focus', function(e){
        if(e.target.matches('.docapp-cart-with-coupon-summary input[type=text].docapp-coupon-input--input')){
          document.querySelector('.docapp-cart-with-coupon-summary .docapp-coupon-input--input-container').classList.add('active-focus');
        }
      }, true);
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          if (document.body.classList.contains('open-drawer')){
            let inputAvailable = document.querySelector('.docapp-cart-with-coupon-summary input[type=text].docapp-coupon-input--input');
            if(inputAvailable){
              inputAvailable.addEventListener('keyup', handleKeyUp);
              inputAvailable.addEventListener('focus', handleFocus);
              observer.disconnect(); // Stop observing after attaching events
            }
          }
        });
      });
      function handleKeyUp(e){
        if(e.target.value != ''){
          document.querySelector('.docapp-cart-with-coupon-summary .docapp-coupon-input--input-container').classList.add('active-input');
        }else{
          document.querySelector('.docapp-cart-with-coupon-summary .docapp-coupon-input--input-container').classList.remove('active-input');
        }
      }
      function handleFocus(e){
        document.querySelector('.docapp-cart-with-coupon-summary .docapp-coupon-input--input-container').classList.add('active-focus');
      }
      observer.observe(document.body, { attributes: true, childList: true, subtree: true });
    }
    if(__st.p == 'cart'){
      input_box();
    }
    document.querySelectorAll('.header-cart').forEach(function(cartButton){
      cartButton.addEventListener('click',function(e){
        if(document.querySelector('.cd-empty-wrap')){
          document.querySelector('body').classList.add('open-drawer');
          document.querySelector('body').classList.remove('open-menu','open-search','open-sort','open-filter','open-quick-buy');
        }else{
          if(document.querySelector('.cd-also-like')) drawerConsider.update();
          let intervalID = setInterval(myCallback,500);
          function myCallback(){
            let inputElement = document.querySelector('.docapp-cart-with-coupon-summary input[type=text].docapp-coupon-input--input');
            if(inputElement){
              document.querySelector('body').classList.add('open-drawer');
              document.querySelector('body').classList.remove('open-menu','open-search','open-sort','open-filter','open-quick-buy');
              clearInterval(intervalID);
            }
          }
          if(__st.p == 'home' && window.innerWidth <= 991){
            if(intentObserver && preventScroll){
              intentObserver.disable();
              preventScroll.disable();
            }
          }
        }
        input_box();
      });
    });
    document.querySelectorAll('.overlay-box,.cart-drawer-close').forEach(function(cartButton){
      cartButton.addEventListener('click',function(e){
        e.preventDefault();
        e.stopImmediatePropagation();
        if(__st.p == 'home' && window.innerWidth <= 991){
          if (intentObserver && preventScroll) {
            intentObserver.enable();
            preventScroll.enable();
          }
        }
        document.querySelector('body').classList.remove('open-drawer','open-menu','open-size','open-search','open_cart_popup','open-sort','open-filter','open-quick-buy','open-shop-look','active-popup');
        document.querySelector('.account-popup-wrap').style.display = 'none';
        if(document.querySelector('.facet-list .coll-filter-inr.active-filter')) document.querySelector('.facet-list .coll-filter-inr.active-filter').classList.remove('active-filter');
        let popup = document.querySelector('.cart_popup');
        if(popup) if(!popup.contains(event.target)) popup.innerHTML = '';
      });
    });
    const url = '/cart.js';
    fetch(url)
    .then((resp) => resp.json())
    .then(function(data) {
      var cart_count = data.item_count;
      document.querySelector('.cartlist').setAttribute('data-count',cart_count);
      document.querySelector('.desk-count').innerHTML = '('+cart_count+')';
      document.querySelector('.mb-count').innerHTML = cart_count;
    })
    .catch(function(error) {
      console.log(error);
    })
  });
}
load_cart();
function removeItem(data_line,data_qty){
  const data = {'id': data_line ,'quantity': data_qty };
  fetch('/cart/change.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  })
  .then((response) => response.json())
  .then((data) => {
    if(document.location.href.indexOf('/cart') > -1) {
      window.location.href = "/cart";
    }else{
      load_cart();
    }
  })
  .catch((error) => {
    console.error('Error:', error);
  });
}
document.body.addEventListener('click', function(e) {
  var cartVariantBtns = document.querySelectorAll('.cd_variantbtn, .cd__variant_list,.cd-select-btn,.cd-variant-wrap');
  var clickedInside = Array.from(cartVariantBtns).some(function(element) {
    return element.contains(e.target) || element === e.target;
  });
  if (!clickedInside){
    document.querySelectorAll('.cd_variant_cls,.grid-variant-outer').forEach(function(element) {
      element.classList.remove('active');
    });
  }
});